import { render, staticRenderFns } from "./ParcelCarrierCards.vue?vue&type=template&id=5ba7e0f2&scoped=true&"
import script from "./ParcelCarrierCards.vue?vue&type=script&lang=js&"
export * from "./ParcelCarrierCards.vue?vue&type=script&lang=js&"
import style0 from "./ParcelCarrierCards.vue?vue&type=style&index=0&id=5ba7e0f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7e0f2",
  null
  
)

export default component.exports